// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","card":"Cards_card__eGUfZ"};